import { render, staticRenderFns } from "./DetailHistoryDoctorDentist.vue?vue&type=template&id=67014152&scoped=true&"
import script from "./DetailHistoryDoctorDentist.vue?vue&type=script&lang=js&"
export * from "./DetailHistoryDoctorDentist.vue?vue&type=script&lang=js&"
import style0 from "./DetailHistoryDoctorDentist.vue?vue&type=style&index=0&id=67014152&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67014152",
  null
  
)

export default component.exports